module.exports = __webpack_public_path__ + "static/media/logo2.2909461f.jpg";